"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicantContext = exports.ScreeningConditionSubsetType = exports.ScreeningConditionOperandType = exports.ReleaseTrack = exports.FeatureFlag = exports.PolicyDocumentsStatus = exports.DocumentSigningProcedure = exports.TriggerIdNotForSecondaryApplicant = exports.LeaseChargeTypeIsDueNow = exports.LeaseChargeTypeIsRecurring = exports.LeaseChargeType = exports.ChargeCodeType = exports.ScreeningConditionActionTakenType = exports.FinancialScreeningConditionType = exports.ScreeningConditionType = exports.IDTypes = exports.IdentificationApplicant = exports.FloorPlanType = exports.LeaseStatusType = exports.AddOnType = exports.UploadedFileVendor = exports.UploadedFileType = exports.EntrataApplicationStage = exports.EntrataApplicationStatus = exports.CustomerType = exports.RelationshipType = exports.AssetTypes = exports.AddressTypes = exports.ExpenseTypes = exports.IncomeTypes = exports.ExpenseInterval = exports.AffordableIncomeInterval = exports.ConventionalIncomeInterval = exports.Interval = exports.ImageLayout = exports.SectionElementType = exports.BlockName = exports.DepositOptionSelection = exports.DefaultDepositOption = exports.BlockType = exports.PageType = exports.FieldType = exports.ResponseJsonDataName = exports.FormChangeAction = exports.FormVersionStatus = exports.OccupancyTypeId = exports.OccupancyType = exports.FieldName = exports.FieldSettingKey = exports.FormType = void 0;
exports.ExternalSyncStatus = exports.UnitSpaceStatusType = exports.ScheduledChargeSource = exports.VerificationFailureAction = exports.StudentSelectionMode = exports.PlaidEvents = exports.CustomFeeAmountType = exports.AmountType = exports.VerificationType = exports.ApplicationSubmissionStatus = exports.NovaErrorType = exports.NovaEnvironment = exports.NovaVerificationStatus = exports.IDIncomeVerificationStatus = exports.WaitlistStatus = exports.AffordableDocumentTypeId = exports.EntrataPermissionName = exports.RouterTargetType = exports.ApplicationType = exports.DisplayLogicConditionalOperator = exports.ValueOperator = exports.DisplayAction = exports.StaticPageId = exports.FORM_BUILDER_PROPERTY_SETTING_KEYS = exports.PropertySettingType = void 0;
exports.mapEntrataOccupancyTypeToId = mapEntrataOccupancyTypeToId;
exports.mapEntrataCustomerTypeToRelationshipType = mapEntrataCustomerTypeToRelationshipType;
exports.LeaseChargeTypeToDisplayText = LeaseChargeTypeToDisplayText;
exports.isCustomFeeAmountType = isCustomFeeAmountType;
var FormType;
(function (FormType) {
    FormType["Application"] = "application";
    FormType["ApplicationTemplate"] = "application-template";
    FormType["Route"] = "route";
})(FormType || (exports.FormType = FormType = {}));
var FieldSettingKey;
(function (FieldSettingKey) {
    FieldSettingKey["MIN_VALUE"] = "minValue";
    FieldSettingKey["MAX_VALUE"] = "maxValue";
    FieldSettingKey["REQUIRED"] = "required";
})(FieldSettingKey || (exports.FieldSettingKey = FieldSettingKey = {}));
var FieldName;
(function (FieldName) {
    FieldName["APPLICANT_TITLE"] = "applicant_title";
    FieldName["APPLICANT_NAME_FIRST"] = "applicant_name_first";
    FieldName["APPLICANT_NAME_MIDDLE"] = "applicant_name_middle";
    FieldName["APPLICANT_NAME_LAST"] = "applicant_name_last";
    FieldName["APPLICANT_NAME_MATERNAL_LAST"] = "applicant_name_maternal_last";
    FieldName["APPLICANT_EMAIL_ADDRESS"] = "applicant_email_address";
    FieldName["APPLICANT_BIRTH_DATE"] = "applicant_birth_date";
    FieldName["APPLICANT_PRIMARY_NUMBER"] = "applicant_primary_number";
    FieldName["APPLICANT_MARITAL_STATUS"] = "applicant_marital_status";
    FieldName["APPLICANT_EMPLOYMENT_STATUS"] = "applicant_employment_status";
    FieldName["APPLICANT_JOB_TITLE"] = "applicant_job_title";
    FieldName["APPLICANT_CURRENT_ANNUAL_INCOME"] = "applicant_current_annual_income";
    FieldName["APPLICANT_EMPLOYER_POSTAL_CODE"] = "applicant_employer_postal_code";
    FieldName["APPLICANT_NAME_PREFERRED"] = "applicant_name_preferred";
    FieldName["APPLICANT_GENDER"] = "applicant_gender";
    FieldName["ALTERNATE_FIRST_NAME"] = "alternate_first_name";
    FieldName["ALTERNATE_MIDDLE_NAME"] = "alternate_middle_name";
    FieldName["ALTERNATE_LAST_NAME"] = "alternate_last_name";
    // Pet fields
    FieldName["APPLICANT_PET_TYPE"] = "applicant_pet_type";
    FieldName["APPLICANT_PET_ASSISTANCE_ANIMAL"] = "applicant_pet_assistance_animal";
    FieldName["APPLICANT_PET_BREED"] = "applicant_pet_breed";
    FieldName["APPLICANT_PET_WEIGHT"] = "applicant_pet_weight";
    FieldName["APPLICANT_PET_SPYED"] = "applicant_pet_spyed";
    FieldName["APPLICANT_PET_HOUSE_BROKEN"] = "applicant_pet_house_broken";
    FieldName["APPLICANT_PET_NAME"] = "applicant_pet_name";
    FieldName["APPLICANT_PET_COLOR"] = "applicant_pet_color";
    FieldName["APPLICANT_PET_AGE"] = "applicant_pet_age";
    FieldName["APPLICANT_PET_GENDER"] = "applicant_pet_gender";
    FieldName["APPLICANT_PET_SPYED_DATE"] = "applicant_pet_spyed_date";
    FieldName["APPLICANT_PET_RABIES_SHOT_DATE"] = "applicant_pet_rabies_shot_date";
    FieldName["APPLICANT_PET_LICENSE_NUMBER"] = "applicant_pet_license_number";
    FieldName["APPLICANT_PET_LICENSE_CITY"] = "applicant_pet_license_city";
    FieldName["APPLICANT_PET_OWNER_NAME"] = "applicant_pet_owner_name";
})(FieldName || (exports.FieldName = FieldName = {}));
var OccupancyType;
(function (OccupancyType) {
    OccupancyType["Conventional"] = "conventional";
    OccupancyType["Student"] = "student";
    OccupancyType["Military"] = "military";
    OccupancyType["Affordable"] = "affordable";
    OccupancyType["FlexibleTerm"] = "flexible-term";
})(OccupancyType || (exports.OccupancyType = OccupancyType = {}));
var OccupancyTypeId;
(function (OccupancyTypeId) {
    OccupancyTypeId[OccupancyTypeId["Conventional"] = 1] = "Conventional";
    OccupancyTypeId[OccupancyTypeId["Commercial"] = 2] = "Commercial";
    OccupancyTypeId[OccupancyTypeId["OtherIncome"] = 4] = "OtherIncome";
    OccupancyTypeId[OccupancyTypeId["Property"] = 5] = "Property";
    OccupancyTypeId[OccupancyTypeId["Affordable"] = 6] = "Affordable";
    OccupancyTypeId[OccupancyTypeId["Owner"] = 7] = "Owner";
    OccupancyTypeId[OccupancyTypeId["Lender"] = 8] = "Lender";
    OccupancyTypeId[OccupancyTypeId["Military"] = 9] = "Military";
    OccupancyTypeId[OccupancyTypeId["Student"] = 10] = "Student";
    OccupancyTypeId[OccupancyTypeId["Hospitality"] = 12] = "Hospitality";
    OccupancyTypeId[OccupancyTypeId["ManufacturedHousing"] = 13] = "ManufacturedHousing";
})(OccupancyTypeId || (exports.OccupancyTypeId = OccupancyTypeId = {}));
function mapEntrataOccupancyTypeToId(occupancyType) {
    switch (occupancyType) {
        case OccupancyType.Affordable:
            return OccupancyTypeId.Affordable;
        case OccupancyType.Military:
            return OccupancyTypeId.Military;
        case OccupancyType.Student:
            return OccupancyTypeId.Student;
        default:
            return OccupancyTypeId.Conventional;
    }
}
var FormVersionStatus;
(function (FormVersionStatus) {
    FormVersionStatus["Draft"] = "draft";
    FormVersionStatus["Active"] = "active";
    FormVersionStatus["Inactive"] = "inactive";
    FormVersionStatus["DraftInactive"] = "draft-inactive";
    FormVersionStatus["Deleted"] = "deleted";
})(FormVersionStatus || (exports.FormVersionStatus = FormVersionStatus = {}));
var FormChangeAction;
(function (FormChangeAction) {
    FormChangeAction["Renamed"] = "renamed";
    FormChangeAction["Updated"] = "updated";
    FormChangeAction["Deleted"] = "deleted";
    FormChangeAction["Created"] = "created";
    FormChangeAction["Published"] = "published";
})(FormChangeAction || (exports.FormChangeAction = FormChangeAction = {}));
var ResponseJsonDataName;
(function (ResponseJsonDataName) {
    ResponseJsonDataName["Applicant"] = "applicantData";
    ResponseJsonDataName["Coapplicant"] = "coApplicant";
    ResponseJsonDataName["Guarantor"] = "guarantor";
    ResponseJsonDataName["Floorplan"] = "floorPlanData";
    ResponseJsonDataName["CurrentAddress"] = "currentAddress";
    ResponseJsonDataName["PreviousAddress"] = "previousAddress";
})(ResponseJsonDataName || (exports.ResponseJsonDataName = ResponseJsonDataName = {}));
var FieldType;
(function (FieldType) {
    FieldType["Amount"] = "amount";
    FieldType["Boolean"] = "boolean";
    FieldType["Checkbox"] = "checkbox";
    FieldType["ChooseMany"] = "choose-many";
    FieldType["ChooseManyDropdown"] = "choose-many-dropdown";
    FieldType["ChooseOne"] = "choose-one";
    FieldType["ChooseOneDropdown"] = "choose-one-dropdown";
    FieldType["Citizenship"] = "citizenship";
    FieldType["CountPicker"] = "count-picker";
    FieldType["CountryDropdown"] = "country-dropdown";
    FieldType["Date"] = "date";
    FieldType["Dropdown"] = "dropdown";
    FieldType["DigitalSignature"] = "digital-signature";
    FieldType["Email"] = "email";
    FieldType["File"] = "file";
    FieldType["LeadSourceDropdown"] = "lead-source-dropdown";
    FieldType["Number"] = "numeric";
    FieldType["OccupationDropDown"] = "occupation-dropdown";
    FieldType["LegalGenderDropDown"] = "legal-gender-dropdown";
    FieldType["GenderIdentityDropDown"] = "gender-identity-dropdown";
    FieldType["PronounsDropDown"] = "pronouns-dropdown";
    FieldType["PreviousHousingArrangements"] = "previous-housing-arrangements";
    FieldType["PreviousSubsidyTypes"] = "previous-subsidy-types";
    FieldType["DisplacementStatuses"] = "displacement-statuses";
    FieldType["Gender"] = "gender";
    FieldType["Title"] = "title";
    FieldType["Ethnicity"] = "ethnicity";
    FieldType["Race"] = "race";
    FieldType["IncomeExceptions"] = "income-exceptions";
    FieldType["StudentExceptions"] = "student-exceptions";
    FieldType["Password"] = "password";
    FieldType["PhoneNumber"] = "phone-number";
    FieldType["Picker"] = "picker";
    FieldType["Radio"] = "radio";
    FieldType["ReferenceLink"] = "reference-link";
    FieldType["SSN"] = "ssn";
    FieldType["StateDropdown"] = "state-dropdown";
    FieldType["StaticText"] = "static-text";
    FieldType["Switch"] = "switch";
    FieldType["Text"] = "text";
    FieldType["TextArea"] = "text-area";
    FieldType["Weight"] = "weight";
    FieldType["YesNo"] = "yes-no";
    FieldType["ZipCode"] = "zip-code";
    FieldType["FaxNumber"] = "fax-number";
})(FieldType || (exports.FieldType = FieldType = {}));
var PageType;
(function (PageType) {
    PageType["Blank"] = "blank";
    PageType["Payment"] = "payment";
    PageType["Documents"] = "documents";
    PageType["Options"] = "options";
    PageType["Roommate"] = "roommate";
    PageType["Interests"] = "interests";
    PageType["Summary"] = "summary";
    PageType["ThankYou"] = "thank-you";
    PageType["FloorPlans"] = "floor-plans";
    PageType["ScreeningConditions"] = "screening-conditions";
    PageType["Offers"] = "offers";
    PageType["Route"] = "route";
})(PageType || (exports.PageType = PageType = {}));
var BlockType;
(function (BlockType) {
    BlockType["AddressCurrent"] = "ADDRESS_CURRENT";
    BlockType["AddressPrevious"] = "ADDRESS_PREVIOUS";
    BlockType["Asset"] = "FINANCIAL_ASSETS";
    BlockType["Coapplicant"] = "COAPPLICANT";
    BlockType["Documents"] = "DOCUMENTS";
    BlockType["IdentificationType"] = "IDENTIFICATION_TYPE";
    BlockType["CitizenStatus"] = "CITIZEN_STATUS";
    BlockType["Income"] = "INCOME";
    BlockType["Pet"] = "PET";
    BlockType["Vehicle"] = "VEHICLE";
    BlockType["Guarantor"] = "GUARANTOR";
    BlockType["GeneralQuestion"] = "GENERAL_QUESTION";
    BlockType["Disability"] = "DISABILITY";
    BlockType["Student"] = "STUDENT";
    BlockType["PoliceSecurityOfficer"] = "POLICE_SECURITY_OFFICER";
    BlockType["MilitaryVeteran"] = "MILITARY_VETERAN";
    BlockType["HouseholdFleeingDomesticViolence"] = "HOUSEHOLD_FLEEING_DOMESTIC_VIOLENCE";
    BlockType["HousedDeclaredDisaster"] = "HOUSED_DECLARED_DISASTER";
    BlockType["AnticipatedAdditionPregnancy"] = "ANTICIPATED_ADDITION_PREGNANCY";
    BlockType["AnticipatedAdditionAdoption"] = "ANTICIPATED_ADDITION_ADOPTION";
    BlockType["AnticipatedAdditionFosterChild"] = "ANTICIPATED_ADDITION_FOSTER_CHILD";
    BlockType["Expense"] = "EXPENSE";
    BlockType["IDVerification"] = "ID_VERIFICATION";
    BlockType["IncomeVerification"] = "INCOME_VERIFICATION";
    BlockType["NovaEligibilityCompass"] = "NOVA_ELIGIBILITY_COMPASS";
    BlockType["RoommateInterests"] = "ROOMMATE_INTERESTS";
    BlockType["RoommateInvitations"] = "ROOMMATE_INVITATIONS";
    BlockType["InstallmentPlans"] = "INSTALLMENT_PLANS";
    BlockType["DepositAlternative"] = "DEPOSIT_ALTERNATIVE";
    BlockType["DepositAlternative3rdParty"] = "DEPOSIT_ALTERNATIVE_3RD_PARTY";
    BlockType["PersonalInformation"] = "PERSONAL_INFORMATION";
    BlockType["Education"] = "EDUCATION";
    BlockType["EmergencyContact"] = "EMERGENCY_CONTACT";
    BlockType["AlternateName"] = "ALTERNATE_NAME";
})(BlockType || (exports.BlockType = BlockType = {}));
var DefaultDepositOption;
(function (DefaultDepositOption) {
    DefaultDepositOption["DepositAlternative"] = "depositAlternative";
    DefaultDepositOption["TraditionalDeposit"] = "traditionalDeposit";
    DefaultDepositOption["NoDefault"] = "noDepositDefault";
})(DefaultDepositOption || (exports.DefaultDepositOption = DefaultDepositOption = {}));
var DepositOptionSelection;
(function (DepositOptionSelection) {
    DepositOptionSelection["Base"] = "base";
    DepositOptionSelection["Enhanced"] = "enhanced";
    DepositOptionSelection["Traditional"] = "traditional";
})(DepositOptionSelection || (exports.DepositOptionSelection = DepositOptionSelection = {}));
var BlockName;
(function (BlockName) {
    BlockName["PersonalInformation"] = "personal-information";
    BlockName["AlternateName"] = "alternate-name";
    BlockName["Pets"] = "pets";
    BlockName["Income"] = "income";
    BlockName["IdentificationType"] = "identification-type";
    BlockName["CurrentAddress"] = "current_address";
    BlockName["PreviousAddress"] = "previous_address";
    BlockName["Coapplicant"] = "coapplicant_block";
    BlockName["PoliceSecurityOfficer"] = "applicant_police_security_officer";
    BlockName["MilitaryVeteran"] = "applicant_military_veteran";
    BlockName["HouseholdFleeingDomesticViolence"] = "applicant_household_fleeing_domestic_violence";
    BlockName["HousedDeclaredDisaster"] = "applicant_housed_declared_disaster";
    BlockName["Disability"] = "applicant_disability";
    BlockName["Student"] = "applicant_student_higher_learning";
    BlockName["CitizenStatus"] = "citizen_status";
    BlockName["InstallmentPlans"] = "installment_plans";
    BlockName["DepositAlternative"] = "deposit_alternative";
    BlockName["DepositAlternative3rdParty"] = "deposit_alternative_3rd_party";
    BlockName["RoommateInterests"] = "roommate_interests";
    BlockName["RoommateInvitations"] = "roommate_invitations";
    BlockName["Vehicles"] = "vehicles";
    BlockName["GeneralQuestion"] = "general_question";
    BlockName["AnticipatedFamilyPregnancy"] = "anticipated_family_pregnancy";
    BlockName["AnticipatedFamilyAdoption"] = "anticipated_family_adoption";
    BlockName["AnticipatedFamilyFosterChild"] = "anticipated_family_foster_child";
    BlockName["Asset"] = "asset";
    BlockName["Expense"] = "expense";
    BlockName["Guarantors"] = "guarantors";
    BlockName["IDVerification"] = "id_verification";
    BlockName["IncomeVerification"] = "income_verification";
    BlockName["Education"] = "education";
    BlockName["EmergencyContact"] = "emergency_contact";
    BlockName["NovaEligibilityCompass"] = "nova_eligibility_compass";
})(BlockName || (exports.BlockName = BlockName = {}));
var SectionElementType;
(function (SectionElementType) {
    SectionElementType["Block"] = "block";
    SectionElementType["Field"] = "field";
})(SectionElementType || (exports.SectionElementType = SectionElementType = {}));
var ImageLayout;
(function (ImageLayout) {
    ImageLayout["Grid"] = "grid";
    ImageLayout["Stacked"] = "stacked";
    ImageLayout["SideBySide"] = "side-by-side";
})(ImageLayout || (exports.ImageLayout = ImageLayout = {}));
var Interval;
(function (Interval) {
    Interval["Hourly"] = "hourly";
    Interval["Daily"] = "daily";
    Interval["Weekly"] = "weekly";
    Interval["BiWeekly"] = "bi-weekly";
    Interval["SemiMonthly"] = "semi-monthly";
    Interval["Monthly"] = "monthly";
    Interval["Quarterly"] = "quarterly";
    Interval["Annually"] = "annually";
    Interval["Yearly"] = "yearly";
    Interval["EveryTwoWeeks"] = "every two weeks";
    Interval["TwicePerMonth"] = "twice per month";
})(Interval || (exports.Interval = Interval = {}));
var ConventionalIncomeInterval;
(function (ConventionalIncomeInterval) {
    ConventionalIncomeInterval["Monthly"] = "monthly";
    ConventionalIncomeInterval["Weekly"] = "weekly";
    ConventionalIncomeInterval["Yearly"] = "yearly";
})(ConventionalIncomeInterval || (exports.ConventionalIncomeInterval = ConventionalIncomeInterval = {}));
var AffordableIncomeInterval;
(function (AffordableIncomeInterval) {
    AffordableIncomeInterval["Hourly"] = "hourly";
    AffordableIncomeInterval["Weekly"] = "weekly";
    AffordableIncomeInterval["BiWeekly"] = "every two weeks";
    AffordableIncomeInterval["SemiMonthly"] = "twice per month";
    AffordableIncomeInterval["Monthly"] = "monthly";
    AffordableIncomeInterval["Annually"] = "yearly";
})(AffordableIncomeInterval || (exports.AffordableIncomeInterval = AffordableIncomeInterval = {}));
var ExpenseInterval;
(function (ExpenseInterval) {
    ExpenseInterval["Hourly"] = "hourly";
    ExpenseInterval["Weekly"] = "weekly";
    ExpenseInterval["Monthly"] = "monthly";
    ExpenseInterval["Yearly"] = "yearly";
})(ExpenseInterval || (exports.ExpenseInterval = ExpenseInterval = {}));
var IncomeTypes;
(function (IncomeTypes) {
    IncomeTypes["ChildSupport"] = "Child Support";
    IncomeTypes["FinancialAid"] = "Financial Aid";
    IncomeTypes["GeneralAssistance"] = "General Relief";
    IncomeTypes["IndianTrust"] = "Indian Trust";
    IncomeTypes["OtherNonWageSource"] = "Other Non Wage Source";
    IncomeTypes["Pensions"] = "Pension Payments";
    IncomeTypes["SupplementalSecurityIncome"] = "SSI";
    IncomeTypes["TemporaryAssistanceForNeedyFamilies"] = "Temporary Assistance";
    IncomeTypes["Unemployment"] = "Unemployment Benefits";
    IncomeTypes["MilitaryPay"] = "Military Pay";
    IncomeTypes["FederalWage"] = "Federal Wage";
    IncomeTypes["BusinessOrRentalIncome"] = "Business Or Rental Income";
    IncomeTypes["CurrentEmployer"] = "Current Employer";
    IncomeTypes["PreviousEmployer"] = "Previous Employer";
    IncomeTypes["SelfEmployer"] = "Self Employer";
    IncomeTypes["OtherIncome"] = "Other Income";
    IncomeTypes["AidToFamiliesWithDependantChildren"] = "Aid To Families With Dependant Children";
    IncomeTypes["Annuities"] = "Annuities";
    IncomeTypes["StudentFinancialAssistanceWorkStudy"] = "Student Financial Assistance Work Study";
    IncomeTypes["StudentFinancialAssistanceScholarships"] = "Student Financial Assistance Scholarships";
    IncomeTypes["StudentFinancialAssistanceGrants"] = "Student Financial Assistance Grants";
    IncomeTypes["StudentFinancialAssistanceLoans"] = "Student Financial Assistance Loans";
    IncomeTypes["StudentFinancialAssistanceParentalAssistance"] = "Student Financial Assistance Parental Assistance";
    IncomeTypes["StudentFinancialAssistanceOther"] = "Student Financial Assistance Other";
    IncomeTypes["ChildSupportOrAlimonyEnforcementAgency"] = "Child Support Or Alimony Enforcement Agency";
    IncomeTypes["ChildSupportOrAlimonyCourtOfLaw"] = "Child Support Or Alimony Court Of Law";
    IncomeTypes["ChildSupportOrAlimonyIndividual"] = "Child Support Or Alimony Individual";
    IncomeTypes["ChildSupportOrAlimonyOther"] = "Child Support Or Alimony Other";
    IncomeTypes["CashContributions"] = "Cash Contributions";
    IncomeTypes["Commissions"] = "Commissions";
    IncomeTypes["Dhs"] = "Dhs";
    IncomeTypes["Disability"] = "Disability";
    IncomeTypes["WorkersCompensation"] = "Workers Compensation";
    IncomeTypes["VaBenefits"] = "Va Benefits";
    IncomeTypes["RetirementPlanPayments"] = "Retirement Plan Payments";
    IncomeTypes["SocialSecurity"] = "Social Security";
    IncomeTypes["GiftPayments"] = "Gift Payments";
    IncomeTypes["VeteransBenefits"] = "Veterans Benefits";
    IncomeTypes["SeverancePackage"] = "Severance Package";
    IncomeTypes["PublicAssistance"] = "Public Assistance";
    IncomeTypes["InterestPayments"] = "Interest Payments";
    IncomeTypes["RentVoucher"] = "Rent Voucher";
    IncomeTypes["NonFederalWages"] = "Non Federal Wages";
})(IncomeTypes || (exports.IncomeTypes = IncomeTypes = {}));
var ExpenseTypes;
(function (ExpenseTypes) {
    ExpenseTypes["ChildCareSchoolOrLookForWork"] = "Child Care School or Look for Work";
    ExpenseTypes["ChildCareWork"] = "Child Care Work";
    ExpenseTypes["Disability"] = "Disability";
    ExpenseTypes["Medical"] = "Medical";
})(ExpenseTypes || (exports.ExpenseTypes = ExpenseTypes = {}));
var AddressTypes;
(function (AddressTypes) {
    AddressTypes["CurrentAddress"] = "current-address";
    AddressTypes["PreviousAddress"] = "previous-address";
    AddressTypes["MailingAddress"] = "mailing-address";
    AddressTypes["BillingAddress"] = "billing-address";
})(AddressTypes || (exports.AddressTypes = AddressTypes = {}));
var AssetTypes;
(function (AssetTypes) {
    AssetTypes["CheckingAccount"] = "Checking Accounts";
    AssetTypes["SavingsAccount"] = "Savings Accounts";
    AssetTypes["CertificateOfDeposit"] = "Certificates Of Deposit";
    AssetTypes["StocksOrBonds"] = "Stocks Or Bonds";
    AssetTypes["RetirementAccount"] = "Retirement Accounts";
    AssetTypes["MutualFunds"] = "Mutual Funds";
    AssetTypes["TrustAccounts"] = "Trust Accounts";
    AssetTypes["CashOnHand"] = "Cash On Hand";
    AssetTypes["LifeInsurance"] = "Life Insurance";
    AssetTypes["OtherAssets"] = "Other Assets";
    AssetTypes["PropertyAsInvestment"] = "Property As Investment";
    AssetTypes["RealEstateSale"] = "Real Estate Sale";
    AssetTypes["RealEstateRent"] = "Real Estate Rent";
    AssetTypes["RealEstateEquity"] = "Real Estate Equity";
})(AssetTypes || (exports.AssetTypes = AssetTypes = {}));
var RelationshipType;
(function (RelationshipType) {
    RelationshipType["Primary"] = "primary";
    RelationshipType["Coapplicant"] = "coapplicant";
    RelationshipType["Guarantor"] = "guarantor";
    RelationshipType["Other"] = "other";
})(RelationshipType || (exports.RelationshipType = RelationshipType = {}));
var CustomerType;
(function (CustomerType) {
    // These values are defined in Entrata Core
    //
    CustomerType["Primary"] = "1";
    CustomerType["Responsible"] = "2";
    CustomerType["NotResponsible"] = "3";
    CustomerType["Guarantor"] = "4";
    CustomerType["NonLeasingOccupant"] = "5";
})(CustomerType || (exports.CustomerType = CustomerType = {}));
function mapEntrataCustomerTypeToRelationshipType(customerType) {
    switch (customerType) {
        case CustomerType.Primary:
            return RelationshipType.Primary;
        case CustomerType.Responsible:
            return RelationshipType.Coapplicant;
        case CustomerType.Guarantor:
            return RelationshipType.Guarantor;
        default:
            return RelationshipType.Other;
    }
}
var EntrataApplicationStatus;
(function (EntrataApplicationStatus) {
    // These values are defined in Entrata Core
    //
    EntrataApplicationStatus["Started"] = "started";
    EntrataApplicationStatus["PartiallyCompleted"] = "partially completed";
    EntrataApplicationStatus["Completed"] = "completed";
    EntrataApplicationStatus["Approved"] = "approved";
    EntrataApplicationStatus["Archived"] = "archived";
    EntrataApplicationStatus["Cancelled"] = "cancelled";
    EntrataApplicationStatus["Expired"] = "expired";
    EntrataApplicationStatus["ConditionallyApproved"] = "conditionally-approved";
    EntrataApplicationStatus["Denied"] = "denied";
})(EntrataApplicationStatus || (exports.EntrataApplicationStatus = EntrataApplicationStatus = {}));
var EntrataApplicationStage;
(function (EntrataApplicationStage) {
    EntrataApplicationStage["Application"] = "application";
    EntrataApplicationStage["Lease"] = "lease";
})(EntrataApplicationStage || (exports.EntrataApplicationStage = EntrataApplicationStage = {}));
var UploadedFileType;
(function (UploadedFileType) {
    UploadedFileType["Unknown"] = "unknown";
    UploadedFileType["PersonalId"] = "personal-id";
    UploadedFileType["ProofOfIncome"] = "proof-of-income";
    UploadedFileType["ProofOfAsset"] = "proof-of-asset";
    UploadedFileType["ProofOfIdentification"] = "proof-of-identification";
})(UploadedFileType || (exports.UploadedFileType = UploadedFileType = {}));
var UploadedFileVendor;
(function (UploadedFileVendor) {
    UploadedFileVendor["Unknown"] = "unknown";
    UploadedFileVendor["AmazonS3"] = "amazon_s3";
})(UploadedFileVendor || (exports.UploadedFileVendor = UploadedFileVendor = {}));
var AddOnType;
(function (AddOnType) {
    AddOnType[AddOnType["Assignable"] = 1] = "Assignable";
    AddOnType[AddOnType["Rentable"] = 2] = "Rentable";
    AddOnType[AddOnType["Service"] = 3] = "Service";
    AddOnType[AddOnType["Special"] = 4] = "Special";
})(AddOnType || (exports.AddOnType = AddOnType = {}));
var LeaseStatusType;
(function (LeaseStatusType) {
    LeaseStatusType[LeaseStatusType["APPLICANT"] = 1] = "APPLICANT";
    LeaseStatusType[LeaseStatusType["CANCELLED"] = 2] = "CANCELLED";
    LeaseStatusType[LeaseStatusType["FUTURE"] = 3] = "FUTURE";
    LeaseStatusType[LeaseStatusType["CURRENT"] = 4] = "CURRENT";
    LeaseStatusType[LeaseStatusType["NOTICE"] = 5] = "NOTICE";
    LeaseStatusType[LeaseStatusType["PAST"] = 6] = "PAST";
})(LeaseStatusType || (exports.LeaseStatusType = LeaseStatusType = {}));
var FloorPlanType;
(function (FloorPlanType) {
    FloorPlanType["Studio"] = "studio";
    FloorPlanType["OneBedroom"] = "one-bed-room";
    FloorPlanType["TwoBedrooms"] = "two-bed-rooms";
    FloorPlanType["ThreeBedrooms"] = "three-bed-rooms";
})(FloorPlanType || (exports.FloorPlanType = FloorPlanType = {}));
var IdentificationApplicant;
(function (IdentificationApplicant) {
    IdentificationApplicant["Person"] = "person";
    IdentificationApplicant["Entity"] = "entity";
})(IdentificationApplicant || (exports.IdentificationApplicant = IdentificationApplicant = {}));
var IDTypes;
(function (IDTypes) {
    IDTypes["SocialSecurityNumber"] = "Social Security Number";
    IDTypes["DriversLicense"] = "Drivers License";
    // Backend wants 'Goverment Issued Picture Id' not 'Government Issued Picture Id'
    IDTypes["GovernmentIssuedPhotoId"] = "Goverment Issued Picture ID";
    IDTypes["MilitaryId"] = "Military ID";
    IDTypes["Passport"] = "Passport Number";
    IDTypes["StudentIdentificationNumber"] = "Student Identification Number";
    IDTypes["Visa"] = "VISA";
})(IDTypes || (exports.IDTypes = IDTypes = {}));
var ScreeningConditionType;
(function (ScreeningConditionType) {
    ScreeningConditionType[ScreeningConditionType["Unknown"] = 0] = "Unknown";
    ScreeningConditionType[ScreeningConditionType["VerifyIdentity"] = 1] = "VerifyIdentity";
    ScreeningConditionType[ScreeningConditionType["VerifyIncome"] = 2] = "VerifyIncome";
    ScreeningConditionType[ScreeningConditionType["IncreaseSecurityDeposit"] = 3] = "IncreaseSecurityDeposit";
    ScreeningConditionType[ScreeningConditionType["IncreaseRent"] = 4] = "IncreaseRent";
    ScreeningConditionType[ScreeningConditionType["AddGuarantor"] = 5] = "AddGuarantor";
    ScreeningConditionType[ScreeningConditionType["CustomScreeningCondition"] = 9] = "CustomScreeningCondition";
    ScreeningConditionType[ScreeningConditionType["OtherCharges"] = 10] = "OtherCharges";
    ScreeningConditionType[ScreeningConditionType["ReplaceSecurityDeposit"] = 11] = "ReplaceSecurityDeposit";
    ScreeningConditionType[ScreeningConditionType["ApprovedWithQualifyingRoommate"] = 12] = "ApprovedWithQualifyingRoommate";
    ScreeningConditionType[ScreeningConditionType["RentalCollectionPaymentProof"] = 13] = "RentalCollectionPaymentProof";
    ScreeningConditionType[ScreeningConditionType["UpfrontRent"] = 14] = "UpfrontRent";
    ScreeningConditionType[ScreeningConditionType["DepositAlternative"] = 15] = "DepositAlternative";
    ScreeningConditionType[ScreeningConditionType["DepositAlternativeIncreaseCoverage"] = 16] = "DepositAlternativeIncreaseCoverage";
    ScreeningConditionType[ScreeningConditionType["ReplaceWithDepositAlternative"] = 17] = "ReplaceWithDepositAlternative";
    ScreeningConditionType[ScreeningConditionType["ReplaceWithDepositAlternativeIncreaseCoverage"] = 18] = "ReplaceWithDepositAlternativeIncreaseCoverage";
    ScreeningConditionType[ScreeningConditionType["AddGuarantorWaiver"] = 20] = "AddGuarantorWaiver";
})(ScreeningConditionType || (exports.ScreeningConditionType = ScreeningConditionType = {}));
var FinancialScreeningConditionType;
(function (FinancialScreeningConditionType) {
    FinancialScreeningConditionType[FinancialScreeningConditionType["VerifyIncome"] = 2] = "VerifyIncome";
    FinancialScreeningConditionType[FinancialScreeningConditionType["IncreaseSecurityDeposit"] = 3] = "IncreaseSecurityDeposit";
    FinancialScreeningConditionType[FinancialScreeningConditionType["IncreaseRent"] = 4] = "IncreaseRent";
    FinancialScreeningConditionType[FinancialScreeningConditionType["OtherCharges"] = 10] = "OtherCharges";
    FinancialScreeningConditionType[FinancialScreeningConditionType["ReplaceSecurityDeposit"] = 11] = "ReplaceSecurityDeposit";
    FinancialScreeningConditionType[FinancialScreeningConditionType["UpfrontRent"] = 14] = "UpfrontRent";
    FinancialScreeningConditionType[FinancialScreeningConditionType["DepositAlternative"] = 15] = "DepositAlternative";
    FinancialScreeningConditionType[FinancialScreeningConditionType["DepositAlternativeIncreaseCoverage"] = 16] = "DepositAlternativeIncreaseCoverage";
})(FinancialScreeningConditionType || (exports.FinancialScreeningConditionType = FinancialScreeningConditionType = {}));
var ScreeningConditionActionTakenType;
(function (ScreeningConditionActionTakenType) {
    ScreeningConditionActionTakenType["Satisfied"] = "satisfied";
    ScreeningConditionActionTakenType["Declined"] = "declined";
})(ScreeningConditionActionTakenType || (exports.ScreeningConditionActionTakenType = ScreeningConditionActionTakenType = {}));
var ChargeCodeType;
(function (ChargeCodeType) {
    ChargeCodeType["Deposit"] = "deposit";
    ChargeCodeType["Rent"] = "rent";
    ChargeCodeType["ConvenienceFee"] = "convenience-fee";
    ChargeCodeType["Miscellaneous"] = "miscellaneous";
})(ChargeCodeType || (exports.ChargeCodeType = ChargeCodeType = {}));
var LeaseChargeType;
(function (LeaseChargeType) {
    // These values are defined in Entrata Core
    //
    // One time charges
    /** Pre-qualification — verify against Entrata `CArTrigger::PRE_QUALIFICATION`. */
    LeaseChargeType[LeaseChargeType["PreQualification"] = 101] = "PreQualification";
    LeaseChargeType[LeaseChargeType["ApplicationCompleted"] = 102] = "ApplicationCompleted";
    LeaseChargeType[LeaseChargeType["ApplicationApproval"] = 103] = "ApplicationApproval";
    LeaseChargeType[LeaseChargeType["OneTime"] = 201] = "OneTime";
    LeaseChargeType[LeaseChargeType["MoveIn"] = 202] = "MoveIn";
    LeaseChargeType[LeaseChargeType["LastMonthOfOccupancy"] = 204] = "LastMonthOfOccupancy";
    LeaseChargeType[LeaseChargeType["Notice"] = 205] = "Notice";
    LeaseChargeType[LeaseChargeType["MoveOut"] = 206] = "MoveOut";
    LeaseChargeType[LeaseChargeType["AnniversaryOfMoveIn"] = 207] = "AnniversaryOfMoveIn";
    LeaseChargeType[LeaseChargeType["EndOfLeaseTerm"] = 208] = "EndOfLeaseTerm";
    LeaseChargeType[LeaseChargeType["EndOfCalendarYear"] = 209] = "EndOfCalendarYear";
    LeaseChargeType[LeaseChargeType["FinalStatement"] = 210] = "FinalStatement";
    LeaseChargeType[LeaseChargeType["RenewalLeaseApproval"] = 211] = "RenewalLeaseApproval";
    LeaseChargeType[LeaseChargeType["RenewalStart"] = 212] = "RenewalStart";
    LeaseChargeType[LeaseChargeType["RenewalOfferAccepted"] = 213] = "RenewalOfferAccepted";
    LeaseChargeType[LeaseChargeType["FirstFullMonth"] = 214] = "FirstFullMonth";
    // Recurring charges
    LeaseChargeType[LeaseChargeType["Hourly"] = 301] = "Hourly";
    LeaseChargeType[LeaseChargeType["Daily"] = 302] = "Daily";
    LeaseChargeType[LeaseChargeType["Weekly"] = 303] = "Weekly";
    LeaseChargeType[LeaseChargeType["EveryTwoWeeks"] = 304] = "EveryTwoWeeks";
    LeaseChargeType[LeaseChargeType["TwicePerMonth"] = 305] = "TwicePerMonth";
    LeaseChargeType[LeaseChargeType["SpecificLeaseMonths"] = 306] = "SpecificLeaseMonths";
    LeaseChargeType[LeaseChargeType["Monthly"] = 307] = "Monthly";
    LeaseChargeType[LeaseChargeType["Quarterly"] = 308] = "Quarterly";
    LeaseChargeType[LeaseChargeType["TwicePerYear"] = 309] = "TwicePerYear";
    LeaseChargeType[LeaseChargeType["Yearly"] = 310] = "Yearly";
    LeaseChargeType[LeaseChargeType["PercentOfSales"] = 311] = "PercentOfSales";
    LeaseChargeType[LeaseChargeType["Nightly"] = 312] = "Nightly";
})(LeaseChargeType || (exports.LeaseChargeType = LeaseChargeType = {}));
/** Entrata recurring lease charge trigger ids */
exports.LeaseChargeTypeIsRecurring = new Set([
    LeaseChargeType.Hourly,
    LeaseChargeType.Daily,
    LeaseChargeType.Weekly,
    LeaseChargeType.EveryTwoWeeks,
    LeaseChargeType.TwicePerMonth,
    LeaseChargeType.SpecificLeaseMonths,
    LeaseChargeType.Monthly,
    LeaseChargeType.Quarterly,
    LeaseChargeType.TwicePerYear,
    LeaseChargeType.Yearly,
    LeaseChargeType.PercentOfSales,
    LeaseChargeType.Nightly,
]);
exports.LeaseChargeTypeIsDueNow = new Set([
    LeaseChargeType.PreQualification,
    LeaseChargeType.ApplicationCompleted,
]);
exports.TriggerIdNotForSecondaryApplicant = new Set([
    LeaseChargeType.MoveIn,
    LeaseChargeType.ApplicationApproval,
]);
function LeaseChargeTypeToDisplayText(type) {
    switch (type) {
        case LeaseChargeType.Hourly:
            return 'Hourly';
        case LeaseChargeType.Daily:
            return 'Daily';
        case LeaseChargeType.Weekly:
            return 'Weekly';
        case LeaseChargeType.EveryTwoWeeks:
            return 'Every Two Weeks';
        case LeaseChargeType.TwicePerMonth:
            return 'Twice Per Month';
        case LeaseChargeType.SpecificLeaseMonths:
            return 'Specific Lease Months';
        case LeaseChargeType.Monthly:
            return 'Monthly';
        case LeaseChargeType.Quarterly:
            return 'Quarterly';
        case LeaseChargeType.TwicePerYear:
            return 'Twice Per Year';
        case LeaseChargeType.Yearly:
            return 'Yearly';
        case LeaseChargeType.PercentOfSales:
            return 'Percent Of Sales';
        case LeaseChargeType.Nightly:
            return 'Nightly';
        default:
            return '';
    }
}
var DocumentSigningProcedure;
(function (DocumentSigningProcedure) {
    DocumentSigningProcedure["SinglePage"] = "one_page";
    DocumentSigningProcedure["MultiplePage"] = "multiple_page";
})(DocumentSigningProcedure || (exports.DocumentSigningProcedure = DocumentSigningProcedure = {}));
var PolicyDocumentsStatus;
(function (PolicyDocumentsStatus) {
    PolicyDocumentsStatus["NotApplicable"] = "na";
    PolicyDocumentsStatus["SuccessfullyGenerated"] = "successfully-generated";
    PolicyDocumentsStatus["DocumentsGenerationFailed"] = "documents-generation-failed";
})(PolicyDocumentsStatus || (exports.PolicyDocumentsStatus = PolicyDocumentsStatus = {}));
var FeatureFlag;
(function (FeatureFlag) {
    FeatureFlag["None"] = "none";
    FeatureFlag["IdIncomeVerificationEnabled"] = "id-income-verification-enabled";
    FeatureFlag["StudentApplicationsEnabled"] = "student-applications-enabled";
    FeatureFlag["PasswordlessAuthentication"] = "password-less-authentication";
})(FeatureFlag || (exports.FeatureFlag = FeatureFlag = {}));
var ReleaseTrack;
(function (ReleaseTrack) {
    ReleaseTrack["Rapid"] = "Rapid";
    ReleaseTrack["Standard"] = "Standard";
})(ReleaseTrack || (exports.ReleaseTrack = ReleaseTrack = {}));
var ScreeningConditionOperandType;
(function (ScreeningConditionOperandType) {
    ScreeningConditionOperandType[ScreeningConditionOperandType["All"] = 0] = "All";
    ScreeningConditionOperandType[ScreeningConditionOperandType["And"] = 1] = "And";
    ScreeningConditionOperandType[ScreeningConditionOperandType["Or"] = 2] = "Or";
})(ScreeningConditionOperandType || (exports.ScreeningConditionOperandType = ScreeningConditionOperandType = {}));
var ScreeningConditionSubsetType;
(function (ScreeningConditionSubsetType) {
    ScreeningConditionSubsetType[ScreeningConditionSubsetType["One"] = 1] = "One";
    ScreeningConditionSubsetType[ScreeningConditionSubsetType["Two"] = 2] = "Two";
})(ScreeningConditionSubsetType || (exports.ScreeningConditionSubsetType = ScreeningConditionSubsetType = {}));
var ApplicantContext;
(function (ApplicantContext) {
    ApplicantContext["FormViewer"] = "form-viewer";
    ApplicantContext["LeadProfile"] = "lead-profile";
    ApplicantContext["ScreeningConditions"] = "screening-conditions";
})(ApplicantContext || (exports.ApplicantContext = ApplicantContext = {}));
var PropertySettingType;
(function (PropertySettingType) {
    PropertySettingType["ChargePetNonRecurringOnceForMultiplePets"] = "CHARGE_PET_NON_RECURRING_ONCE_FOR_MULTIPLE_PETS";
    PropertySettingType["HidePaymentForAppApprovedAndLeaseApproved"] = "HIDE_PAYMENT_BUTTON_FOR_APPLICATION_APPROVED_AND_LEASE_APPROVED";
    PropertySettingType["HistoricalApplicationDisplayDays"] = "HISTORICAL_APPLICATION_DISPLAY_DAYS";
    PropertySettingType["LockDownApplicationDisplayDays"] = "LOCK_DOWN_APPLICATION_AT";
    PropertySettingType["ShowCoApplicantInviteOnApplication"] = "SHOW_CO_APPLICANT_INVITE_ON_APPLICATION";
    PropertySettingType["WaitlistEnabled"] = "ENABLE_WAITLIST";
    PropertySettingType["ImmediateMoveInEnabled"] = "ENABLE_IMMEDIATE_MOVE_IN";
    PropertySettingType["PropertyDetailsPetPolicy"] = "PROPERTY_DETAILS_PET_POLICY";
    PropertySettingType["AddUnitSpaceAmenityChargesUponAssignment"] = "ADD_UNIT_SPACE_AMENITY_CHARGES_UPON_ASSIGNMENT";
    PropertySettingType["DisplayOptionalCustomFees"] = "DISPLAY_OPTIONAL_CUSTOM_FEES";
    PropertySettingType["StudentAvailabilityLeaseBy"] = "STUDENT_AVAILABILITY_LEASE_BY";
})(PropertySettingType || (exports.PropertySettingType = PropertySettingType = {}));
exports.FORM_BUILDER_PROPERTY_SETTING_KEYS = Object.values(PropertySettingType);
var StaticPageId;
(function (StaticPageId) {
    StaticPageId["Offers"] = "8c66f564-171f-4bcf-811d-400861bf4533";
})(StaticPageId || (exports.StaticPageId = StaticPageId = {}));
var DisplayAction;
(function (DisplayAction) {
    DisplayAction["Show"] = "show";
    DisplayAction["Hide"] = "hide";
    DisplayAction["Require"] = "require";
})(DisplayAction || (exports.DisplayAction = DisplayAction = {}));
var ValueOperator;
(function (ValueOperator) {
    ValueOperator["Equals"] = "eq";
    ValueOperator["GreaterThan"] = "gt";
    ValueOperator["LessThan"] = "lt";
    ValueOperator["Contains"] = "contains";
    ValueOperator["Includes"] = "includes";
    ValueOperator["NotEqual"] = "nql";
    // New date-based operators for dynamic year comparisons
    ValueOperator["YearsOlderThan"] = "years_older_than";
    ValueOperator["YearsYoungerThan"] = "years_younger_than";
})(ValueOperator || (exports.ValueOperator = ValueOperator = {}));
var DisplayLogicConditionalOperator;
(function (DisplayLogicConditionalOperator) {
    DisplayLogicConditionalOperator["And"] = "and";
    DisplayLogicConditionalOperator["Or"] = "or";
})(DisplayLogicConditionalOperator || (exports.DisplayLogicConditionalOperator = DisplayLogicConditionalOperator = {}));
var ApplicationType;
(function (ApplicationType) {
    ApplicationType["Application"] = "application";
    ApplicationType["Route"] = "route";
})(ApplicationType || (exports.ApplicationType = ApplicationType = {}));
var RouterTargetType;
(function (RouterTargetType) {
    RouterTargetType["Application"] = "application";
    RouterTargetType["Field"] = "field";
})(RouterTargetType || (exports.RouterTargetType = RouterTargetType = {}));
var EntrataPermissionName;
(function (EntrataPermissionName) {
    EntrataPermissionName["None"] = "none";
    EntrataPermissionName["AddDeleteApplicants"] = "add_delete_applicants";
    EntrataPermissionName["EditApplicationLeaseTermDetails"] = "edit_application_lease_term_details";
    EntrataPermissionName["EditApplicationMoveInDateDetails"] = "edit_application_move_in_date_details";
    EntrataPermissionName["ViewApplicationMaskedSsnInfo"] = "view_application_masked_ssn_info_action";
    EntrataPermissionName["ViewApplicationMaskedIdentificationNumber"] = "view_application_masked_identification_number_action";
    EntrataPermissionName["ViewApplicationMaskedDob"] = "view_application_masked_dob_action";
    EntrataPermissionName["EditApplicationUnitDetails"] = "edit_application_unit_details";
    EntrataPermissionName["MarkApplicationsAsComplete"] = "mark_applications_as_complete";
    EntrataPermissionName["EditApplicationDetails"] = "edit_application_details";
})(EntrataPermissionName || (exports.EntrataPermissionName = EntrataPermissionName = {}));
var AffordableDocumentTypeId;
(function (AffordableDocumentTypeId) {
    AffordableDocumentTypeId[AffordableDocumentTypeId["Student"] = 10] = "Student";
    AffordableDocumentTypeId[AffordableDocumentTypeId["PoliceSecurityOfficer"] = 14] = "PoliceSecurityOfficer";
    AffordableDocumentTypeId[AffordableDocumentTypeId["Disability"] = 7] = "Disability";
    AffordableDocumentTypeId[AffordableDocumentTypeId["Veteran"] = 8] = "Veteran";
    AffordableDocumentTypeId[AffordableDocumentTypeId["Disaster"] = 13] = "Disaster";
})(AffordableDocumentTypeId || (exports.AffordableDocumentTypeId = AffordableDocumentTypeId = {}));
var WaitlistStatus;
(function (WaitlistStatus) {
    WaitlistStatus["NotOffered"] = "not_offered";
    WaitlistStatus["Offered"] = "offered";
    WaitlistStatus["Accepted"] = "accepted";
    WaitlistStatus["Declined"] = "declined";
})(WaitlistStatus || (exports.WaitlistStatus = WaitlistStatus = {}));
var IDIncomeVerificationStatus;
(function (IDIncomeVerificationStatus) {
    IDIncomeVerificationStatus["Success"] = "success";
    IDIncomeVerificationStatus["Failed"] = "failed";
    IDIncomeVerificationStatus["InProgress"] = "inprogress";
    IDIncomeVerificationStatus["Initiated"] = "initiated";
    IDIncomeVerificationStatus["ReInitiated"] = "reinitiated";
    IDIncomeVerificationStatus["NotStarted"] = "notstarted";
})(IDIncomeVerificationStatus || (exports.IDIncomeVerificationStatus = IDIncomeVerificationStatus = {}));
/** Status values returned by Applications' NOVA verification API. */
var NovaVerificationStatus;
(function (NovaVerificationStatus) {
    NovaVerificationStatus["Initiated"] = "initiated";
    NovaVerificationStatus["InProgress"] = "inprogress";
    NovaVerificationStatus["Success"] = "success";
    NovaVerificationStatus["Failed"] = "failed";
    NovaVerificationStatus["Error"] = "error";
})(NovaVerificationStatus || (exports.NovaVerificationStatus = NovaVerificationStatus = {}));
var NovaEnvironment;
(function (NovaEnvironment) {
    NovaEnvironment["Sandbox"] = "sandbox";
    NovaEnvironment["Production"] = "production";
})(NovaEnvironment || (exports.NovaEnvironment = NovaEnvironment = {}));
/** Documented error codes returned by the NovaConnect widget. */
var NovaErrorType;
(function (NovaErrorType) {
    NovaErrorType["DuplicateExternalId"] = "DUPLICATE_EXTERNAL_ID";
    NovaErrorType["InternalError"] = "INTERNAL_ERROR";
    NovaErrorType["InvalidConsumerId"] = "INVALID_CONSUMER_ID";
    NovaErrorType["InvalidPrefillsPiiMissing"] = "INVALID_PREFILLS_PII_MISSING";
    NovaErrorType["InvalidPrefillAddress"] = "INVALID_PREFILL_ADDRESS";
    NovaErrorType["InvalidPrefillCity"] = "INVALID_PREFILL_CITY";
    NovaErrorType["InvalidPrefillDob"] = "INVALID_PREFILL_DOB";
    NovaErrorType["InvalidPrefillEmail"] = "INVALID_PREFILL_EMAIL";
    NovaErrorType["InvalidPrefillFirstName"] = "INVALID_PREFILL_FIRST_NAME";
    NovaErrorType["InvalidPrefillIncome"] = "INVALID_PREFILL_INCOME";
    NovaErrorType["InvalidPrefillKey"] = "INVALID_PREFILL_KEY";
    NovaErrorType["InvalidPrefillLastName"] = "INVALID_PREFILL_LAST_NAME";
    NovaErrorType["InvalidPrefillPhone"] = "INVALID_PREFILL_PHONE";
    NovaErrorType["InvalidPrefillState"] = "INVALID_PREFILL_STATE";
    NovaErrorType["InvalidPrefillStatedEmployerNames"] = "INVALID_PREFILL_STATED_EMPLOYER_NAMES";
    NovaErrorType["InvalidPrefillZip"] = "INVALID_PREFILL_ZIP";
    NovaErrorType["InvalidProduct"] = "INVALID_PRODUCT";
    NovaErrorType["InvalidToken"] = "INVALID_TOKEN";
    NovaErrorType["MismatchedProductId"] = "MISMATCHED_PRODUCT_ID";
    NovaErrorType["RequestTimeout"] = "REQUEST_TIMEOUT";
    NovaErrorType["SupplierError"] = "SUPPLIER_ERROR";
    NovaErrorType["UnknownCustomer"] = "UNKNOWN_CUSTOMER";
})(NovaErrorType || (exports.NovaErrorType = NovaErrorType = {}));
var ApplicationSubmissionStatus;
(function (ApplicationSubmissionStatus) {
    ApplicationSubmissionStatus["Submitting"] = "Submitting";
    ApplicationSubmissionStatus["Completed"] = "Completed";
    ApplicationSubmissionStatus["Failed"] = "Failed";
})(ApplicationSubmissionStatus || (exports.ApplicationSubmissionStatus = ApplicationSubmissionStatus = {}));
var VerificationType;
(function (VerificationType) {
    VerificationType["IncomeVerification"] = "income_verification";
    VerificationType["DocumentVerification"] = "document_verification";
    VerificationType["PayrollVerification"] = "payroll_verification";
    VerificationType["IdentityVerification"] = "identity_verification";
})(VerificationType || (exports.VerificationType = VerificationType = {}));
var AmountType;
(function (AmountType) {
    AmountType["FixedAmount"] = "fixed";
    AmountType["AverageAmount"] = "average";
    AmountType["RangeAmount"] = "range";
    AmountType["VariesAmount"] = "varies";
})(AmountType || (exports.AmountType = AmountType = {}));
/**
 * Amount-type strings as returned by the Entrata Pricing API for custom fees.
 * Mirrors the arms handled by the Prospect Portal CustomFeesMapper::formatFeeAmount.
 */
var CustomFeeAmountType;
(function (CustomFeeAmountType) {
    CustomFeeAmountType["FixedAmount"] = "Fixed Amount";
    CustomFeeAmountType["AverageAmount"] = "Average Amount";
    CustomFeeAmountType["RangeAmount"] = "Range Amount";
    CustomFeeAmountType["MinAvgMaxAmount"] = "Min, Avg, Max Amount";
    CustomFeeAmountType["CustomText"] = "Custom Text";
    CustomFeeAmountType["VariesByUsageText"] = "Varies by Usage Text";
})(CustomFeeAmountType || (exports.CustomFeeAmountType = CustomFeeAmountType = {}));
/**
 * Narrows an arbitrary Pricing API amount-type string to a known custom-fee
 * type, so callers can pass it through without an unchecked type assertion.
 */
function isCustomFeeAmountType(value) {
    return (value != null &&
        Object.values(CustomFeeAmountType).includes(value));
}
var PlaidEvents;
(function (PlaidEvents) {
    PlaidEvents["SubmitDocumentsSuccess"] = "SUBMIT_DOCUMENTS_SUCCESS";
})(PlaidEvents || (exports.PlaidEvents = PlaidEvents = {}));
/**
 * Student Selection Mode
 *
 * Defines the mode for student floor plan selection:
 * - BULK_UNIT_ASSIGNMENT: Applicants select floorplan/spaceOption only (no unit drilling)
 * - STUDENT_UNIT_SELECTION: Applicants select down to specific units
 */
var StudentSelectionMode;
(function (StudentSelectionMode) {
    StudentSelectionMode["BULK_UNIT_ASSIGNMENT"] = "bulk_unit_assignment";
    StudentSelectionMode["STUDENT_UNIT_SELECTION"] = "student_unit_selection";
})(StudentSelectionMode || (exports.StudentSelectionMode = StudentSelectionMode = {}));
var VerificationFailureAction;
(function (VerificationFailureAction) {
    VerificationFailureAction["DoNothing"] = "do_nothing";
    VerificationFailureAction["LockdownTheApplication"] = "lockdown_the_application";
    VerificationFailureAction["ApplicationCantBeCompleted"] = "application_cant_be_completed";
})(VerificationFailureAction || (exports.VerificationFailureAction = VerificationFailureAction = {}));
var ScheduledChargeSource;
(function (ScheduledChargeSource) {
    ScheduledChargeSource["Pricing"] = "pricing";
    ScheduledChargeSource["Billing"] = "billing";
})(ScheduledChargeSource || (exports.ScheduledChargeSource = ScheduledChargeSource = {}));
var UnitSpaceStatusType;
(function (UnitSpaceStatusType) {
    UnitSpaceStatusType[UnitSpaceStatusType["OccupiedNoNotice"] = 3] = "OccupiedNoNotice";
    UnitSpaceStatusType[UnitSpaceStatusType["NoticeRented"] = 5] = "NoticeRented";
    UnitSpaceStatusType[UnitSpaceStatusType["NoticeUnrented"] = 9] = "NoticeUnrented";
    UnitSpaceStatusType[UnitSpaceStatusType["VacantUnrentedReady"] = 2] = "VacantUnrentedReady";
    UnitSpaceStatusType[UnitSpaceStatusType["VacantUnrentedNotReady"] = 4] = "VacantUnrentedNotReady";
    UnitSpaceStatusType[UnitSpaceStatusType["VacantRentedNotReady"] = 6] = "VacantRentedNotReady";
    UnitSpaceStatusType[UnitSpaceStatusType["VacantRentedReady"] = 8] = "VacantRentedReady";
})(UnitSpaceStatusType || (exports.UnitSpaceStatusType = UnitSpaceStatusType = {}));
var ExternalSyncStatus;
(function (ExternalSyncStatus) {
    ExternalSyncStatus["Succeeded"] = "succeeded";
    ExternalSyncStatus["Failed"] = "failed";
})(ExternalSyncStatus || (exports.ExternalSyncStatus = ExternalSyncStatus = {}));
